import React, { useState, useEffect } from "react"
import AnimationRevealPage from "helpers/AnimationRevealPage.js"
import { Container, ContentWithPaddingXl } from "components/misc/Layouts"
import tw from "twin.macro"
import styled from "styled-components"
import { css } from "styled-components/macro"
import Header from "components/headers/light.js"
import Footer from "components/footers/MiniCenteredFooter"
import { SectionHeading } from "components/misc/Headings"
import { PrimaryButton } from "components/misc/Buttons"
import AuthTokenRequest from 'helpers/axiosInstances'
import { formatDate } from 'helpers/utils'
import { TableDespacho, TableNormas } from "components/tableNormas"
import noticia5 from 'assets/images/noticia5.jpg'
import noticia6 from 'assets/images/noticia6.jpg'
import noticia7 from 'assets/images/noticia7.jpg'
import noticia8 from 'assets/images/noticia8.jpg'

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900`;
const HeadingNormas = tw.h2`mt-4 font-black text-left text-2xl sm:text-4xl lg:text-4xl text-center md:text-center leading-tight`;
const Posts = tw.div`mt-6 sm:-mr-8 flex flex-wrap`;
const PostContainer = styled.div`
  ${tw`mt-10 w-full sm:w-1/2 lg:w-1/3 sm:pr-8`}
  ${props =>
		props.principal &&
		css`
      ${tw`w-full!`}
      ${Post} {
        ${tw`sm:flex-row! h-full sm:pr-4`}
      }
      ${Image} {
        ${tw`sm:h-96 sm:min-h-full sm:w-1/2 lg:w-2/3 sm:rounded-t-none sm:rounded-l-lg`}
      }
      ${Info} {
        ${tw`sm:-mr-4 sm:pl-8 sm:flex-1 sm:rounded-none sm:rounded-r-lg sm:border-t-2 sm:border-l-0`}
      }
      ${Description} {
        ${tw`text-sm mt-3 leading-loose text-gray-600 font-medium`}
      }
    `}
`;
const Post = tw.div`cursor-pointer flex flex-col bg-gray-100 rounded-lg`;
const Image = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`h-64 w-full bg-cover bg-center rounded-t-lg`}
`;
const Info = tw.div`p-8 border-2 border-t-0 rounded-lg rounded-t-none`;
const Category = tw.div`uppercase text-primary-500 text-xs font-bold tracking-widest leading-loose after:content after:block after:border-b-2 after:border-primary-500 after:w-8`;
const CreationDate = tw.div`mt-4 uppercase text-gray-600 italic font-semibold text-xs`;
const Title = tw.div`mt-1 font-black text-2xl text-gray-900 group-hover:text-primary-500 transition duration-300`;
const Description = tw.div``;
const TextSecond = tw.p`mt-4 font-black text-left  text-left md:text-left leading-tight font-light`

const ButtonContainer = tw.div`flex justify-center`;
const LoadMoreButton = tw(PrimaryButton)`mt-16 mx-auto`;

export default ({
	headingText = "Normas legales",
	headingText2 = " Noticias"
}) => {
	const [visible, setVisible] = useState(13)
	const [news, setNews] = useState([])
	const filter = {
		page: 1,
		rows: 20,
		id: 0,
		title_tb: 0,
		title: "",
		shortDesc_tb: 0,
		shortDesc: "",
		sortcolumn: "",
		sortorder: ""
	}
	const onLoadMoreClick = () => {
		setVisible(v => v + 12)
	}

	const columns1 = [
		{ title: "Código" },
		{ title: "Norma" },
		{ title: "Nombre" },
		{ title: "Publicación" },
		{ title: "Vigencia" }
	]

	const data1 = [
		{
			codigo: "GJA-01",
			norma: "Ley 27444",
			nombre: "Ley del Procedimiento Administrativo General",
			enlace: "https://www.sunat.gob.pe/legislacion/procedim/normasadua/gja-01.htm",
			publicacion: "11.04.2001",
			vigencia: "11.10.2001",
			className: "bold",
			align: "center"
		},
		{
			codigo: "GJA-02",
			norma: "Ley 27584",
			nombre: "Ley que regula el Proceso Contencioso Administrativo",
			enlace: "https://www.sunat.gob.pe/legislacion/procedim/normasadua/gja-02.htm",
			publicacion: "07.12.2001",
			vigencia: "16.04.2002",
			className: "principal",
			align: "center"
		},
		{
			codigo: "GJA-03",
			norma: "Decreto Legislativo 1053",
			nombre: "Ley General de Aduanas",
			enlace: "https://www.sunat.gob.pe/legislacion/procedim/normasadua/gja-03.htm",
			publicacion: "27.06.2008",
			vigencia: "28.06.2008(*)\n17.03.2009(**)\n01.10.2010(***)",
			className: "bold",
			align: "center"
		},
		{
			codigo: "GJA-04",
			norma: "DS.342-2016-EF",
			nombre: "Arancel de Aduanas",
			enlace: "https://www.sunat.gob.pe/legislacion/procedim/normasadua/gja-04.htm",
			publicacion: "31.12.2021",
			vigencia: "01.01.2022",
			className: "bold",
			align: "center"
		},
		{
			codigo: "GJA-05",
			norma: "Ley 28008",
			nombre: "Ley de los Delitos Aduaneros",
			enlace: "https://www.sunat.gob.pe/legislacion/procedim/normasadua/gja-05.htm",
			publicacion: "19.06.2003",
			vigencia: "28.08.2003",
			className: "bold",
			align: "center"
		}
	]


	const columns2 = [
		{ title: "Sumilla" },
		{ title: "Resolución" },
		{ title: "Fecha de Publicación Diario Oficial El Peruano" }
	]

	const data2 = [
		{
			codigo: "",
			norma: "Resolución de Superintendencia Nacional Adjunta de Aduanas que Aprueba la Facultad Discrecional para no sancionar Infracciones Previstas en la Ley General De Aduanas relacionadas con la modificación del Artículo 195 del Reglamento de la Ley General de Aduanas",
			nombre: "R. S.N.A.A. N° 000014-2025-SUNAT/300000",
			enlace: "https://www.sunat.gob.pe/legislacion/superAdjunta/rsnata/2025/RSNAA-000014-2025.pdf",
			publicacion: "26/06/2025",
			vigencia: "",
			className: "bold",
			align: "center"
		},
		{
			codigo: "",
			norma: "Resolución de Superintendencia Nacional Adjunta de Aduanas que aprueba la facultad discrecional para no sancionar infracciones previstas en la Ley General de Aduanas relacionadas con la transmisión de la documentación que sustenta la Declaración Aduanera de Mercancías al Régimen de importación para el consumo en forma digitalizada",
			nombre: "R. S.N.A.A. N° 000008-2025-SUNAT/300000",
			enlace: "https://www.sunat.gob.pe/legislacion/superAdjunta/rsnata/2025/RSNAA-000008-2025.pdf",
			publicacion: "24/03/2025",
			vigencia: "",
			className: "bold",
			align: "center"
		},
		{
			codigo: "",
			norma: "Resolución de Superintendencia Nacional Adjunta de Aduanas que aprueba la facultad discrecional para no sancionar infracciones previstas en la Ley General de Aduanas relacionadas con las operaciones en el Terminal Portuario Multipropósito de Chancay",
			nombre: "R. S.N.A.A. N° 000007-2025-SUNAT/300000",
			enlace: "https://www.sunat.gob.pe/legislacion/superAdjunta/rsnata/2025/RSNAA-000007-2025.pdf",
			publicacion: "21/02/2025",
			vigencia: "",
			className: "bold",
			align: "center"
		}
	]

	const columns3 = [
		{ title: "Sumilla" },
		{ title: "Resolución" },
		{ title: "Fecha de Publicación Diario Oficial El Peruano" }
	]

	const data3 = [
		{
			codigo: "",
			norma: "Resolución de Superintendencia que aprueba el procedimiento general “Certificación del operador económico autorizado” DESPA-PG.29 (versión 4)",
			nombre: "RESOLUCION - Nº 000281-2025/SUNAT",
			enlace: "https://busquedas.elperuano.pe/dispositivo/NL/2434856-1",
			publicacion: "4 set. 2025",
			vigencia: "",
			className: "bold",
			align: "center"
		}
	]

	useEffect(() => {
		const fetchNoticias = async () => {
			const { data } = await AuthTokenRequest().post('/news/examine', filter)
			setNews(data.items === null ? [] : data.items)
		}
		fetchNoticias()
	}, [])


	return (
		<AnimationRevealPage disabled>
			<Header roundedHeaderButton={true} />
			<Container>
				<ContentWithPaddingXl>
					<HeadingRow>
						<Heading>{headingText}</Heading>
					</HeadingRow>
					<hr></hr>
					{/* Enlaces pdf de google drive */}
					<HeadingNormas style={{ marginTop: '50px' }}>Normas Legales Aduaneras</HeadingNormas>
					<div style={{ width: '80%', margin: 'auto' }}>
						<TableNormas columns={columns1} data={data1} />
					</div>
					<div style={{ width: '80%', margin: 'auto', marginBottom: '50px' }}>
						<TextSecond style={{ color: '#1f3864', fontSize: '1rem', fontWeight: 'bold' }}>
							Cada una de las normas legales aduaneras contiene normas asociadas.
							<br />
							(*) Entró en vigencia sólo el articulo 31° con excepción del inciso (d).
							<br />
							(**) Entró en vigencia parcialmente conforme a su reglamento.
							<br />
							(***) Entró en plenamente en vigencia.
						</TextSecond>
					</div>
					{/* segunda norma */}
					<HeadingNormas style={{ marginTop: '50px' }}>Resoluciones de la Superintendencia Nacional Adjunta de Aduanas</HeadingNormas>
					<div style={{ width: '80%', margin: 'auto' }}>
						<TableNormas columns={columns2} data={data2} />
					</div>
					{/* tercera norma */}
					<HeadingNormas style={{ marginTop: '50px' }}>Procedimientos de Despacho</HeadingNormas>
					<div style={{ width: '80%', margin: 'auto' }}>
						<TableDespacho />
					</div>
					{/* cuarta norma */}
					<HeadingNormas style={{ marginTop: '50px' }}>Procedimiento OEA 2025 / SUNAT</HeadingNormas>
					<div style={{ width: '80%', margin: 'auto' }}>
						<TableNormas columns={columns3} data={data3} />
					</div>
					{/* ---------------------- */}
					<HeadingRow>
						<Heading>{headingText2}</Heading>
					</HeadingRow>
					<hr></hr>
					<div style={{ width: '80%', margin: 'auto' }}>
						<li style={{ marginTop: 40 }}>
							<a style={{ textDecoration: "underline" }} href="/files/LIPA-ANC-2026.pdf" target="_blank" rel="noopener noreferrer">
								LIPA-ANC-I-7-1 Instructivo de Seguridad y Amenazas-2026
							</a>
						</li>
					</div>
					<Posts>
						{news.slice(0, visible).map((noticia, index) => (
							<PostContainer key={index} principal={noticia.principal}>
								<Post className="group" as="a" href={`/components/innerPages/NoticiaPage?id=${noticia.id}`}>
									<Image imageSrc={noticia.imageSrc} />
									<Info>
										<Category>Noticia</Category>
										<CreationDate>{formatDate(noticia.date)}</CreationDate>
										<Title>{noticia.title}</Title>
										{noticia.principal && noticia.shortDesc && <Description>{noticia.shortDesc}</Description>}
									</Info>
								</Post>
							</PostContainer>
						))}
					</Posts>
					{visible < news.length && (
						<ButtonContainer>
							<LoadMoreButton onClick={onLoadMoreClick}>Ver más</LoadMoreButton>
						</ButtonContainer>
					)}
					{/* Actualización 2026 – Normativa Aduanera */}
					<HeadingNormas style={{ marginTop: '50px' }}>Actualización 2026 – Normativa Aduanera</HeadingNormas>
					<figure>
						<img
							src={noticia5}
							alt="noticia5"
							style={{ margin: "auto", width: "100%" }}
						/>
					</figure>
					<figure>
						<img
							src={noticia6}
							alt="noticia6"
							style={{ margin: "auto", width: "100%" }}
						/>
					</figure>
					<figure>
						<img
							src={noticia7}
							alt="noticia7"
							style={{ margin: "auto", width: "100%" }}
						/>
					</figure>
					<figure>
						<img
							src={noticia8}
							alt="noticia8"
							style={{ margin: "auto", width: "100%" }}
						/>
					</figure>
				</ContentWithPaddingXl>
			</Container>
			<Footer />
		</AnimationRevealPage>
	)
}